import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/styles';
import { CssBaseline } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { HelmetProvider } from 'react-helmet-async';

import store from 'redux/store';
import theme from 'theme';
import { indexRoutes } from 'routes';
import { AuthProvider } from 'context/AuthContext';
import { ScrollReset } from './components';
import * as serviceWorker from './serviceWorker';
import Route from './routes/AuthRoute';
import { ConfigProvider } from 'context/ConfigContext';
import ReactGA from 'react-ga4';

import './i18n';

function App() {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    console.log('IndexRoutes', indexRoutes);
  }

  return (
    <Router>
      <ScrollReset />
      <AuthProvider>
        <Switch>
          {indexRoutes.map((prop, key) => {
            return <Route {...prop} key={key} />;
          })}
        </Switch>
      </AuthProvider>
    </Router>
  );
}

const container = document.getElementById('root');

const root = createRoot(container);

if (process.env.NODE_ENV && process.env.NODE_ENV === 'production') {
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);
}

root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <HelmetProvider>
          <ConfigProvider>
            <App />
          </ConfigProvider>
        </HelmetProvider>
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  </Provider>
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
